export default "__VITE_ASSET__i7WDx8Iw__"